import React from "react";
import { Link, withRouter } from "react-router-dom";
import BaseButton from "../BaseButton";
import SupportingText from "../SupportingText";

class BottomNavigationItem extends React.Component {
  render() {
    const {
      children,
      activeTextColor,
      icon,
      onClick,
      href,
      location
    } = this.props;
    const isActive = href === location.pathname;
    return (
      <BaseButton
        onClick={onClick}
        inlineStyle={{
          justifyContent: "flex-end",
          height: "56px"
        }}
        className="w-full h-full flex-col pb-1"
      >
        <Link to={href}>
          <div className="flex-1">{icon ? icon(isActive) : null}</div>
          <SupportingText
            textSize="sm"
            textColor={isActive ? activeTextColor : "grey-darker"}
            fontWeight="medium"
            textAlign="center"
          >
            {children}
          </SupportingText>
        </Link>
      </BaseButton>
    );
  }
}

export default withRouter(BottomNavigationItem);



// WEBPACK FOOTER //
// ./src/BottomNavigationItem/BottomNavigationItem.js